import { render } from "./modalgenererecriture.vue?vue&type=template&id=10a946d1&scoped=true"
import script from "./modalgenererecriture.vue?vue&type=script&lang=js"
export * from "./modalgenererecriture.vue?vue&type=script&lang=js"

import "./modalgenererecriture.vue?vue&type=style&index=0&id=10a946d1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a946d1"]])

export default __exports__